<template>
  <v-navigation-drawer
    :value="is_polls_sidebar"
    :class="$style.sidebar"
    :touchless="touchless"
    width="600px"
    height="100%"
    fixed
    right
  >
    <v-list-item class="mb-2">
      <div :class="$style.head">
        <div :class="$style.title">Активные опросы</div>
        <v-btn
          icon
          @click="toggle_polls_sidebar(!is_polls_sidebar)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-list-item>

    <v-card
      v-for="item in polls"
      :key="item.poll_id"
      :class="[$style.card, 'mb-6']"
      :options.sync="table_options"
    >
      <div :class="[$style.status, 'mb-6']">
        <span :class="$style.itemTitle">{{ item.title }}</span>
        <div>
          <PollStatus
            v-if="item.status"
            :poll_status="poll_status(item)"
          />
        </div>
      </div>
      <div :class="[$style.subText, $style.date, 'mb-4']">{{ item.published_at }}</div>
      <div :class="[$style.subText, $style.desc, 'mb-4']">{{ item.description }}</div>
      <div
        v-if="item.expired_time"
        :class="[$style.subText, $style.time,'d-flex mb-4']"
      >
        <v-icon
          color="accent darken-4"
          class="mr-2"
        >
          mdi-clock-outline
        </v-icon>
        {{ item.expired_time }}
      </div>
      <div class="d-flex">
        <v-btn
          v-if="is_show_btn(item)"
          text
          color="accent darken-4"
          class="d-flex align-center ml-auto"
          @click="go_to_poll(item)"
        >
          <div v-if="is_not_completed(item.status.slug)">Продолжить опрос</div>
          <div v-else-if="is_retake_allowed(item)">Пройти опрос повторно</div>
          <div v-else>Пройти опрос</div>
          <v-icon
            small
            class="ml-1"
          >
            mdi-arrow-right
          </v-icon>
        </v-btn>
      </div>
    </v-card>
  </v-navigation-drawer>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import { global_store, polls_store } from '@/store';
import { Polls } from '@/modules/polls/types';
import PollStatus from '@/modules/polls/components/PollStatus.vue';
import { PollsStatuses } from '@/enums';

const { state, mutations } = polls_store;

@Component({
  components: {
    PollStatus,
  },
})
export default class NotificationsSidebar extends Vue {
  touchless = true;

  get is_polls_sidebar() {
    return global_store.state.is_polls_sidebar;
  }

  get polls() {
    return state.polls;
  }

  get table_options() {
    return state.table_options;
  }

  is_not_completed(slug: string) {
    return slug === PollsStatuses.NOT_COMPLETED;
  }

  is_retake_allowed(item: Polls.Poll) {
    return item.is_retake_allowed && item.status.slug === PollsStatuses.COMPLETED;
  }

  is_show_btn(item: Polls.Poll) {
    const { slug } = item.status;
    const { is_retake_allowed } = item;

    return slug === PollsStatuses.NEW || slug === PollsStatuses.NOT_COMPLETED || is_retake_allowed;
  }

  toggle_polls_sidebar(value: boolean) {
    global_store.mutations.POLLS_SIDEBAR_TOGGLE(value);
  }

  poll_status(item: Polls.Poll) {
    return item.status?.slug ?? '';
  }

  go_to_poll(item: Polls.Poll) {
    if (this.$route.params.id === `${item.poll_id}`) {
      this.toggle_polls_sidebar(!this.is_polls_sidebar);
      return;
    }

    this.$router.push({
      name: Polls.Pages.POLL,
      params: {
        id: `${item.poll_id}`,
      },
    });

    if (this.$route.name === Polls.Pages.POLL && this.$route.params.id !== `${item.poll_id}` && item.poll_id) {
      polls_store.actions.get_poll_by_id(item.poll_id);
    }

    mutations.SET_START_TIME(new Date().toISOString());
    this.toggle_polls_sidebar(!this.is_polls_sidebar);
  }
}

</script>

<style module lang="scss">
.sidebar {
  flex-shrink: 0;
  z-index: 9999999;
  transition: 0.5s;
  box-shadow: 0px 4px 16px -2px rgba(19, 20, 28, 0.08);
  background-color: #EDEFF5 !important;
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.title {
  font-size: 28px;
  font-weight: 500;
  line-height: 32px;
}

.card {
  padding: 16px;
  margin: 0 16px;

}

.status {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.itemTitle {
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
}

.subText {
  color: $primary_darken3;
}

.date {
  font-size: 12px;
  line-height: 20px;
}

.desc {
  font-size: 14px;
  line-height: 20px;
}

.time {
  font-size: 16px;
  line-height: 24px;
}
</style>
